import { create } from "zustand";
import { createStoreWithSelectors } from "./createStoreWithSelectors";

export const DEFAULT_FIRST_FORM_VALUE = "";

interface FilterState {
  county: string;
  bedrooms: string;
  minPrice: string;
  maxPrice: string;
  setCounty: (county: string) => void;
  setBedrooms: (bedrooms: string) => void;
  setMinPrice: (minPrice: string) => void;
  setMaxPrice: (maxPrice: string) => void;
}

const filterInitialValues = {
  county: DEFAULT_FIRST_FORM_VALUE,
  bedrooms: DEFAULT_FIRST_FORM_VALUE,
  minPrice: DEFAULT_FIRST_FORM_VALUE,
  maxPrice: DEFAULT_FIRST_FORM_VALUE,
};

const filterStore = create<FilterState>()((set) => ({
  ...filterInitialValues,
  setCounty: (county) => set(() => ({ county })),
  setBedrooms: (bedrooms) => set(() => ({ bedrooms })),
  setMinPrice: (minPrice) => set(() => ({ minPrice })),
  setMaxPrice: (maxPrice) => set(() => ({ maxPrice })),
}));

export const useFilterStore = createStoreWithSelectors(filterStore);
